import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';

import { progressCounts } from '#leadOverviewFeature/components/LeadOverviewPage/JobProgressBar/progressCounts';
import { jobProgressOptions } from '#leadOverviewFeature/models/jobs/queries';

const POLL_MS = 2000;

/**
 * Live progress of the assistant's contact enrichment inside its step card. Mounted only while
 * the step is pending, so it keeps polling through the short window in which the job is not yet
 * dispatched (the status endpoint answers 404 then) and stops by unmounting.
 */
const EnrichmentProgress = ({ jobId }) => {
	const { data } = useQuery({
		...jobProgressOptions('contactEnrichment', jobId),
		refetchInterval: POLL_MS,
	});
	const progress = data?.progress;
	const percent = Math.max(3, progress?.percent ?? 0);
	const counts = progressCounts(progress);

	return (
		<div className="space-y-1 px-3 pb-2.5">
			<div className="h-1.5 w-full overflow-hidden rounded-full bg-bgBase-500">
				<div className="h-full bg-primary-500 transition-all duration-300" style={{ width: `${percent}%` }} />
			</div>
			<p className="text-xs text-bgBase-800">{counts ?? 'Anreicherung wird gestartet …'}</p>
		</div>
	);
};

EnrichmentProgress.propTypes = { jobId: PropTypes.string.isRequired };

export default EnrichmentProgress;
